import { render, staticRenderFns } from "./InstanceTopBarTabs.vue?vue&type=template&id=f11496e0&scoped=true"
import script from "./InstanceTopBarTabs.vue?vue&type=script&lang=js"
export * from "./InstanceTopBarTabs.vue?vue&type=script&lang=js"
import style0 from "./InstanceTopBarTabs.vue?vue&type=style&index=0&id=f11496e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11496e0",
  null
  
)

export default component.exports